import { render } from "./payment_details.vue?vue&type=template&id=1655f97f"
import script from "./payment_details.vue?vue&type=script&lang=js"
export * from "./payment_details.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__